import { axiosInstance } from "./AxiosDefaults";

export const getAllImportedParticipant = (): Promise<any> => {
  return axiosInstance.get("/imported-participant", {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getOneImportedParticipant = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/imported-participant`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const changeOneImportedParticipant = (id: string): Promise<any> => {
  return axiosInstance.put(`${`/imported-participant`}/change/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createExcel = async (file: any, id: string) => {
  const formData = new FormData();
  formData.append("excelFile", file);
  try {
    return axiosInstance.post(
      `imported-participant/upload-excel/${id}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  } catch (error) {
    throw error;
  }
};
